// URL query-param helpers using URLSearchParams for robust, encoding-safe parsing.
// These replace ad-hoc regexes that were brittle against param ordering and
// percent-encoded characters.

import { Base64 } from "js-base64";

export interface ParsedInvite {
  code: string;
  n: string;
  deviceLink: boolean;
}

/**
 * Extract invite data from an invite URL. Returns null when required params
 * are absent or the payload cannot be decoded.
 */
export function parseInviteUrl(url: string): ParsedInvite | null {
  try {
    const params = new URLSearchParams(new URL(url).search);
    const code = params.get("code");
    const d = params.get("d");
    if (!code || !d) return null;
    const json = Base64.decode(d);
    const data = JSON.parse(json);
    if (data.n) {
      return { code, n: data.n, deviceLink: params.get("link") === "1" };
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * Extract the checkout return status from a query string (e.g. window.location.search).
 * Returns "success", "cancel", or null.
 */
export function parseCheckoutParam(search: string): "success" | "cancel" | null {
  const val = new URLSearchParams(search).get("checkout");
  if (val === "success" || val === "cancel") return val;
  return null;
}
